import { api } from "../config/api";

export const getTrainingVideos = async (audience) => {
  const response = await api.get("/trainingvideos", { params: { audience } });
  return response.data;
};